import type { PlannedInput } from "../../../api/content/stepPlans";
import { pickViewsOf } from "../../workflows/presentation/resolvePresentation";

/** Where a value field picks: items in a project's library, recorded results in a project. */
export interface PickedIn {
  /** The project whose library an `item` input picks from (F38); none where items are not picked, as at a start. */
  readonly items?: string | undefined;
  /** The project whose undecided results a recorded-result input picks from (A8). */
  readonly results?: string | undefined;
}

/** Whether the input's own picker edits it, and so states its need there. */
export function picksItsValue(input: PlannedInput, pickedIn: PickedIn): boolean {
  return (input.takesItem && pickedIn.items !== undefined) || (pickViewsOf(input.accepts, input.lineages).has("result") && pickedIn.results !== undefined);
}
